import type { SplitTutorialVideoLanguage } from '../graphql/getSplitTutorialVideoUrl';

const LANGUAGE_MAP: Record<string, SplitTutorialVideoLanguage> = {
    zh: 'ZH',
    en: 'EN',
    es: 'ES',
};

/**
 * 界面语言（如 'zh'、'zh-CN'、'en-US'、'es'）→ 教学视频语言枚举。
 * 识别不了返回 undefined（接口不传 language，后端按中文）。
 */
export function toTutorialVideoLanguage(lang?: string | null): SplitTutorialVideoLanguage | undefined {
    if (!lang) return undefined;
    const base = lang.trim().toLowerCase().split('-')[0];
    return LANGUAGE_MAP[base];
}
